module.exports = __webpack_public_path__ + "media/dashboard/assets/images/menu-icons/ai_bot-e276aefcf9c7875e63c88c71f27ebdad.svg";